"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }

var _XXF5DFSGcjs = require('./XXF5DFSG.cjs');


var _5OZ7J4C2cjs = require('./5OZ7J4C2.cjs');


var _NKGUWTUCcjs = require('./NKGUWTUC.cjs');


var _MLKK6UGOcjs = require('./MLKK6UGO.cjs');


var _EV33XSIBcjs = require('./EV33XSIB.cjs');



var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/menu/menu-store.ts
var _menustore = require('@ariakit/core/menu/menu-store'); var Core = _interopRequireWildcard(_menustore);
function useMenuStoreProps(store, update, props) {
  _3BSDKDKDcjs.useUpdateEffect.call(void 0, update, [props.combobox, props.parent, props.menubar]);
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "values", "setValues");
  return Object.assign(
    _NKGUWTUCcjs.useHovercardStoreProps.call(void 0, 
      _MLKK6UGOcjs.useCompositeStoreProps.call(void 0, store, update, props),
      update,
      props
    ),
    {
      combobox: props.combobox,
      parent: props.parent,
      menubar: props.menubar
    }
  );
}
function useMenuStore(props = {}) {
  const parent = _XXF5DFSGcjs.useMenuContext.call(void 0, );
  const menubar = _5OZ7J4C2cjs.useMenubarContext.call(void 0, );
  const combobox = _EV33XSIBcjs.useComboboxProviderContext.call(void 0, );
  props = {
    ...props,
    parent: props.parent !== void 0 ? props.parent : parent,
    menubar: props.menubar !== void 0 ? props.menubar : menubar,
    combobox: props.combobox !== void 0 ? props.combobox : combobox
  };
  const [store, update] = _FH6HQ5JNcjs.useStore.call(void 0, Core.createMenuStore, props);
  return useMenuStoreProps(store, update, props);
}




exports.useMenuStoreProps = useMenuStoreProps; exports.useMenuStore = useMenuStore;
